<template>
    <keep-alive>
        <div class="modal-mask type2">
            <div class="modal-wrapper">
                <div class="modal_size sm3_size">
                    <a href="javascript:" class="ui_close_type2" type="button" @click="$emit('close')">
                        <span class="sr_only"></span>
                    </a>
                    <dl class="modal_content">
                        <dt class="ellipsis desc">
                            <i>{{$t('BUTTON.GLOBAL.CONFIRM')}}</i>
                            <p class="desc">
                                {{$t('MESSAGE.EUR.BP.SAVED')}}
                            </p>
                        </dt>
                        <dd>
                            <table class="view_table noLine">
                                <colgroup>
                                    <col width="270px">
                                    <col class="*">
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <th>{{$t('FIELD.GLOBAL.ID')}}({{$t('FIELD.GLOBAL.EMAIL')}})</th>
                                        <td>{{pParams.userEmail}}</td>
                                    </tr>
                                    <tr>
                                        <th>{{$t('FIELD.PROFILE.COMPANY.NAME')}}</th>
                                        <td>{{pParams.companyNm}}</td>
                                    </tr>
                                    <tr>
                                        <th>{{$t('FIELD.COMPANY.REGISTRATION.NUMBER')}}</th>
                                        <td>{{pParams.companyNo}}</td>
                                    </tr>
                                    <tr>
                                        <th>{{$t('FIELD.EUR.COMP.ADDR')}}</th>
                                        <td>{{pParams.address}}</td>
                                    </tr>
                                    <tr>
                                        <th>{{$t('FIELD.POSTAL.CODE')}}</th>
                                        <td>{{pParams.zipCd}}</td>
                                    </tr>
                                    <tr>
                                        <th>{{$t('FIELD.COMPANY.WEBSITE.ADDRESS')}}</th>
                                        <td>{{pParams.homeUrl}}</td>
                                    </tr>
                                    <tr>
                                        <th>{{$t('FIELD.EUR.FIRST.NAME')}}</th>
                                        <td>{{pParams.contactFrstNm}}</td>
                                    </tr>
                                    <tr>
                                        <th>{{$t('FIELD.EUR.LAST.NAME')}}</th>
                                        <td>{{pParams.contactLastNm}}</td>
                                    </tr>
                                    <tr>
                                        <th>{{$t('FIELD.CONTACT.PHONE.NUMBER')}}</th>
                                        <td>{{pParams.contactPhoneNo}}</td>
                                    </tr>
                                    <tr>
                                        <th>{{$t('FIELD.EUR.APE.CODES')}}</th>
                                        <td>{{pParams.apeCodes}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </dd>
                        <dd class="scroll_btm">
                            <div class="btn_modal_wrap topLine mt-0 text-center">
                                <button class="bt-type-m black" @click="closeAndGoStep3">{{$t('BUTTON.GLOBAL.CLOSE')}}</button>
                            </div>
                        </dd>
                    </dl>
                </div>
            </div>
        </div>
    </keep-alive>
</template>

<script>
import Vue          from 'vue';
import { SDLUtil }  from '@/utils';

export default {
    name: 'UserJoinInfoPopup',
    components: {
    },
    computed: {
    },
    props: {
        pParams: {
            type: Object
        },
        rtnJoinFunc: {
            type: Function,
        },
    },
    data() {
        return {
        };
    },
    methods: {
        closeAndGoStep3() {
            this.rtnJoinFunc('Hello mati.');
            this.$emit('close');
        }
    },
    mounted() {
//        this.$nextTick(() => {
//        });
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/eur/user/JoinedConfirmPopup.vue